import React from 'react';

const TextArea = ({ label, placeholder, rows, register, error }) => {
  return (
    <>
      <label className="block mb-2 text-base text-left font-medium text-gray-900">{label}</label>
      <textarea
        rows={rows}
        className="block p-2.5 w-full text-base text-gray-900 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500"
        placeholder={placeholder}
        {...register}
      ></textarea>
      {error && <p className="text-red-500 text-left mt-1">{label} tidak boleh kosong</p>}
    </>
  );
};

export default TextArea;
